export function checkHttpStatus(response) {
    if (response) {
        const statusCode = response.data?.code;
        if ((response.status >= 200 && response.status < 300) &&
            (!statusCode || (statusCode >= 200 && statusCode < 300))) {
            return response;
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    }
}

export function createReducer(initialState, reducerMap) {
    return (state = initialState, action) => {
        const reducer = reducerMap[action.type];
        return reducer ? reducer(state, action.payload) : state;
    };
}
